// Entity
export interface ActivitySessionWaitingContactsInterface {
  id?: number;
  center_id?: number;
}

export interface ActivitySessionWaitingContactsFormModelInterface {
  id: number;
  center_id: number;
}

// Permission
export const ActivitySessionWaitingContactPermissionName: string =
  'activity_session_waiting_contact';

// Table Filters interfaces
export interface ActivitySessionWaitingContactsDefaultFilterTableInterface {
  search?: string;
}

// Table items interface
export interface ActivitySessionWaitingContactsDefaultTableItemInterface {
  id: number;
  center_id: number;
}
